import { UseCaseInteractor } from '../../../kernel/use-case'
import { UpdateExternalDataResponse, ExternalDataPayload } from '../domain/entities'
import { ExternalDataRepository } from '../domain/external-data.repository'

export const updateExternalDataUseCase: UseCaseInteractor<
  [ExternalDataRepository],
  [payload: ExternalDataPayload],
  UpdateExternalDataResponse
> = (externalDataRepository) => async (payload) => externalDataRepository.updateExternalData(payload)
